import {UserRole} from "../../../../types/auth.types";
import {ResourceParams, resources} from "../../../../models/resource/resources";
import {DocumentRows} from "../types/document-modal.types";
import {
  actFields,
  bankDetailsFields,
  contractFields,
  edoFields,
  eridFields,
  oneCFields,
  paymentFields
} from "./documents-modal-row-config";

export const documentResourceType: ResourceParams = resources['advertisement-documents'];
export const documentsResourceType: ResourceParams = resources['documents'];
export const fieldsWithStatus = ['contract', 'erid', 'payment', 'act', 'edo', 'oneC'];
export const allowedEditRoles: Array<UserRole> = ['ROLE_DOCUMENT_EDITOR', 'ROLE_DOCUMENT_MANAGER', 'ROLE_ADMIN'];

export const documentRows: Array<DocumentRows> = [
  {
    key: 'bankDetails',
    title: 'Реквизиты',
    documentRow: bankDetailsFields
  },
  {
    key: 'contract',
    title: 'Договор',
    documentRow: contractFields
  },
  {
    key: 'erid',
    title: 'Ерид',
    documentRow: eridFields
  },
  {
    key: 'payment',
    title: 'Оплата',
    documentRow: paymentFields
  },
  {
    key: 'act',
    title: 'Акт',
    documentRow: actFields,
    isSeparator: true
  },
  {
    key: 'edo',
    title: 'ЭДО',
    documentRow: edoFields
  },
  {
    key: 'oneC',
    title: '1С',
    documentRow: oneCFields
  }
]
